import { styled } from "styled-components";

export const Item = styled.div<{ hasAccess?: boolean }>`
  margin-bottom: 10px;
  text-decoration: none;
  display: block;
  position: relative;
  filter: ${({ hasAccess }) => (hasAccess ? "none" : "blur(3px)")};
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const Divider = styled.div`
  width: 100%;
  padding-right: 10;
  padding-left: 10;
  border-color: ${({ theme }) => theme.colors.fillPrimary};
  border-width: 1px;
  border-style: solid;
  opacity: 0.2;
`;
